import React, { useContext } from 'react';
import UserInfo from '@/components/userinfo-in-header';
import Logo from '@/components/logo';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { insideIframe } from '@/constants';
import { Tooltip, Space } from 'antd';
import ProviderCrumb from './provider-crumb';
import './header.less';

function toHelpCenter() {
  window.open('/help/');
}

function HeaderCrumbs({ crumbs }) {
  if (!crumbs || crumbs.length === 0) return null;

  return (
    <span style={{ paddingTop: 4 }}>
      <Space split={<span style={{ color: 'rgba(0, 0, 0, .45)' }}>/</span>}>
        {crumbs.map((item, index) => {
          if (index === crumbs.length - 1)
            return (
              <span key={index} style={{ cursor: 'default', color: 'inherit' }}>
                {item.title}
              </span>
            );

          return (
            <a style={{ color: 'rgba(0, 0, 0, .45)' }} key={item.link} href={item.link}>
              {item.title}
            </a>
          );
        })}
      </Space>
    </span>
  );
}

export default function Header({ logout }) {
  const { crumbs } = useContext(ProviderCrumb);
  // 如果在iframe内不展示头部
  if (insideIframe) return null;
  return (
    <div className="outest-header">
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          gap: 16,
        }}
      >
        <a href="/">
          <Logo />
        </a>
        <HeaderCrumbs crumbs={crumbs} />
      </div>
      <div className="outest-header-right-part">
        <div className="outest-toHelpCenter-btn" onClick={toHelpCenter}>
          <Tooltip title="帮助中心">
            <QuestionCircleOutlined style={{ cursor: 'pointer', fontSize: '20px', color: 'rgba(0,0,0,0.65)' }} />
          </Tooltip>
        </div>
        <UserInfo logout={logout} />
      </div>
    </div>
  );
}
